/*
	日期：2025/08/24
	地点：四川 成都
	作者：终结司令官
	
	介绍：数据模拟
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

import myMock from 'mockjs'

// 加载首页模拟数据
import homeAPIdata from './mockServerData/home.js'

// 加载用户模拟数据
import userAPIdata from './mockServerData/user.js'
import permissionAPIdata from './mockServerData/permission.js'

// 定义 Mock 请求拦截方法
// myMock.mock('/api/getData11','get',function() {
//	// 拦截到的请求后的处理函数
//	console.log('拦截到了！');
//	return {};
//})

// 设置数据模拟链接
myMock.mock('http://unit.ioe.top/api/getData/','get',homeAPIdata.getstatisticalData);

// 用户操作
myMock.mock('http://unit.ioe.top/api/user/create/','post',userAPIdata.createUser);
myMock.mock('http://unit.ioe.top/api/user/update/','post',userAPIdata.updateUser);
myMock.mock('http://unit.ioe.top/api/user/delete/','post',userAPIdata.deleteUser);
//myMock.mock('http://unit.ioe.top/api/user/list/','get',userAPIdata.getUserList);
myMock.mock(/\/api\/user\/list/, 'get', userAPIdata.getUserList);
myMock.mock(/\/api\/user\/login/, 'post', permissionAPIdata.loginUser);
//myMock.mock('/http:\/\/unit\.ioe\.top\/api\/user\/list\/.*/','get',userAPIdata.getUserList);
//myMock.mock('http://unit.ioe.top/api/user/list/*','get',userAPIdata.getUserList);
//myMock.mock('https://unit.ioe.top/api/user/list/*','get',userAPIdata.getUserList);